import config from "./config";
import firebase from "firebase/compat/app";
import { reset as resetAnalytics } from "../analytics";

import "firebase/compat/auth";

const app = firebase.initializeApp(config);

app.auth().useDeviceLanguage();

export function auth() {
  return app.auth();
}

export function signup(email, password) {
  return auth().createUserWithEmailAndPassword(email, password);
}

/**
 * must be called only for resends
 */
export function sendEmailVerification() {
  const user = auth().currentUser;
  if (!user) {
    return Promise.reject({
      code: "auth/user-token-expired",
      message: "Please sign in again.",
    });
  }
  return user.sendEmailVerification({
    url: "https://app.1link.io/#/almost-done",
  });
}

export function loginViaGoogle() {
  const provider = new firebase.auth.GoogleAuthProvider();
  return auth().signInWithPopup(provider);
}

export function signupViaGoogle() {
  return loginViaGoogle();
}

export function getJwtToken() {
  return auth().currentUser.getIdToken();
}

export function login(email, password) {
  return auth().signInWithEmailAndPassword(email, password);
}

// lets main.js tell a sign-out the visitor asked for from a session that
// firebase ended on its own
let loggingOut = false;

export function isLoggingOut() {
  return loggingOut;
}

export async function logout() {
  loggingOut = true;
  await auth().signOut();
  // reset here, not at each call site: this is the one function every
  // sign-out path goes through, and a shared device must not merge the next
  // session into this identity
  resetAnalytics();
}

export function updatePassword(newPassword) {
  const user = firebase.auth().currentUser;
  return user.updatePassword(newPassword);
}

/**
 * emails a confirmation link to the new address: the account only switches
 * to it once the link is clicked, and firebase then ends every session.
 * Not updateEmail(), which the production project refuses outright (Email
 * Enumeration Protection is on there, and off in the test project)
 */
export function verifyBeforeUpdateEmail(newEmail) {
  const user = firebase.auth().currentUser;
  return user.verifyBeforeUpdateEmail(newEmail, {
    url: "https://app.1link.io/#/login",
  });
}

export function updateProfile(data) {
  const user = firebase.auth().currentUser;
  /*
  data = {
    displayName: "Jane Q. User",
    photoURL: "https://example.com/jane-q-user/profile.jpg"
  }
  */
  return user.updateProfile(data);
}

/**
 * authenticate before any updates
 */
export function reauthenticate(currentPassw) {
  const user = firebase.auth().currentUser;
  const credential = firebase.auth.EmailAuthProvider.credential(
    user.email,
    currentPassw,
  );
  return user.reauthenticateWithCredential(credential);
}
